import React from 'react';
import aImg from '../img/g.png';
import bImg from '../img/b.png';
import cImg from '../img/c.png';
import dImg from '../img/dd.png';
import aRemovebg from '../img/sinfondo/g-removebg-preview.png';
import bRemovebg from '../img/sinfondo/b-removebg-preview.png';
import cRemovebg from '../img/sinfondo/c-removebg-preview.png';
import dRemovebg from '../img/sinfondo/d-removebg-preview.png';
import '../CardsPrincipal.css';

function CardsPrincipal() {
  return (
    <div className="cards-container">
      <div className="custom-card">
        <article> 
          <img src={aImg} alt="Imagen A" />
          <img src={aRemovebg} alt="Imagen A sin fondo" />
        </article>
        <div className="card-body">
          <p className="card-text">Descripción de la tarjeta 1.</p>
        </div>
      </div>
      <div className="custom-card">
        <article>
          <img src={bImg} alt="Imagen B" />
          <img src={bRemovebg} alt="Imagen B sin fondo" />
        </article>
        <div className="card-body">
          <p className="card-text">Descripción de la tarjeta 2.</p>
        </div>
      </div>
      <div className="custom-card">
        <article>
          <img src={cImg} alt="Imagen C" />
          <img src={cRemovebg} alt="Imagen C sin fondo" />
        </article>
        <div className="card-body">
          <p className="card-text">Descripción de la tarjeta 3.</p>
        </div>
      </div>
      <div className="custom-card">
        <article>
          <img src={dImg} alt="Imagen D" />
          <img src={dRemovebg} alt="Imagen D sin fondo" />
        </article>
        <div className="card-body">
          <p className="card-text">Descripción de la tarjeta 4.</p>
        </div>
      </div>
    </div>
  );
}

export default CardsPrincipal;
